import React, {useState, useEffect} from 'react';
import { Table, Button, Row, Col, Switch, Tooltip, notification, Select } from 'antd';
import { FaPlusCircle, FaPencilAlt } from "react-icons/fa";
import { customerId, organizationId } from '../config.json';
import { getActiveCategories } from '../services/CategoriesService'
import { addProduct, getAllProducts, updateProduct, updateProductImage } from '../services/ProductsService'

import ProductModalNew from './ProductModalNew';
import ProductModalEdit from './ProductModalEdit';

const { Option } = Select;

function Products(){
    const[dataProducts, setDataProducts] = useState([]);
    const[dataCategories, setDataCategories] = useState([]);
    const[categoryId, setCategoryId] = useState("S");
    const[btnNewDisabled, setbtnNewDisabled] = useState(true);
    const[modalVisibleNew, setModalVisibleNew] = useState(false);
    const[modalVisibleEdit, setModalVisibleEdit] = useState(false);
    const[urlThumbnail, setUrlThumbnail] = useState("");
    const[nameProduct, setNameProduct] = useState("");
    const[descProduct, setDescProduct] = useState("");
    const[priceProduct, setPriceProduct] = useState(0);
    const[activeProduct, setActiveProduct] = useState("");
    const[idProduct, setIdProduct] = useState("");
    const[tableProductsLoading, setTableProductsLoading] = useState(false);

    const origin = window.location.origin;

    useEffect(() => {
        async function process(){
          const { data } = await getActiveCategories(customerId, organizationId);
          setDataCategories(data);
          console.log(data)
        }
        process();
        
    },[])

    const msNotification = (type, title, desc) => {
        notification[type]({
          message: title,
          description:
            desc,
        });
    };

    function handleChangeCategory(value) {
        if(value != "S"){
            setbtnNewDisabled(false);
            setTableProductsLoading(true);
            setCategoryId(value);
            async function allProducts(){
                const { data } = await getAllProducts(customerId, organizationId, value);
                setDataProducts(data);
                setTableProductsLoading(false);
              }
              allProducts();
            
        }else{
            setDataProducts([]);
            setbtnNewDisabled(true);
        }
        
    }

    const handleClickModalNew = () => {
        setModalVisibleNew(true);
    }
  
    const handleClickModalEdit = (record) => {
        setNameProduct(record.name);
        setUrlThumbnail(record.uriThumbnail);
        setIdProduct(record.id);
        setDescProduct(record.description);
        setPriceProduct(record.price);
        setActiveProduct(record.active)
        setModalVisibleEdit(true);
    }

    const onChangeActive = (record, checked) => {
        const request = {
            "CustomerId": customerId,
            "OrganizationId": organizationId,
            "Id": record.id,
            "CategoryId": categoryId,
            "Name": record.name,
            "Description": record.description,
            "Price": record.price,
            "Active": checked
          };

        async function updateTheProduct(){
          try {
              await updateProduct(request);  
              const dataProd = [...dataProducts]
              dataProd.find(x => x.id === record.id).active = checked;
              setDataProducts(dataProd); 
              msNotification('success', 'Producto', 'Se actualizó el producto.' );
          } catch (error) {
            msNotification('error', 'Producto', 'Error al actualizar el producto.' );
          } finally {
              //setUploading(false);
          }
        }
        updateTheProduct();
    }

    const handleOkModalNew = (data) =>{
      const dataProd = [...dataProducts];
      const exist = dataProd.find(x => x.id === data.prodId);
      if(exist === undefined){
        var dataimg = data.image == null ? null : {
          "Name": data.name,
          "Position": 1,
          "MediaType": data.mediaType,
          "ImageContent": data.image
        };
        
        const request = {
          "Id": data.prodId,
          "CustomerId": customerId,
          "OrganizationId": organizationId,
          "CategoryId": categoryId,
          "Name": data.prodName,
          "Description": data.prodDesc,
          "Price": parseFloat(data.prodPrice),
          "Active": true,
          "Image": dataimg
        };
        async function addNewProduct(){
            try {
                const { data } = await addProduct(request);
                const tempProducts = [...dataProducts];
                tempProducts.push(data);
                setDataProducts(tempProducts);
                msNotification('success', 'Producto', 'Se creó el producto.' );
            } catch (errors) {
                msNotification('error', 'Producto', 'Error al crear el producto.' );
            } finally {
              setModalVisibleNew(false);
            }
        }
        addNewProduct();
      }else{
        msNotification('warning', 'Producto', `El Id: ${data.prodId} ya lo tiene asignado el producto: ${exist.name}.` );
      }
        
  
    }

    const handleOkModalEdit = (datac) =>{
        const requestProduct = {
            "CustomerId": customerId,
            "OrganizationId": organizationId,
            "Id": idProduct,
            "CategoryId": categoryId,
            "Name": datac.prodName,
            "Description": datac.prodDesc,
            "Price": parseFloat(datac.prodPrice),
            "Active": activeProduct
          };
        const requestImage = {
          'customerId': customerId,
          'organizationId': organizationId,
          'id': idProduct,
          'name': datac.name,
          'position': 1,
          'mediaType': datac.mediaType,
          'imageContent': datac.image,
          "CategoryId": categoryId,
        }
        async function updateTheProduct(){
            try {
                await updateProduct(requestProduct);   
                const dataProd = [...dataProducts]
                dataProd.find(x => x.id === idProduct).name = datac.prodName;
                dataProd.find(x => x.id === idProduct).description = datac.prodDesc;
                dataProd.find(x => x.id === idProduct).price = datac.prodPrice;
                setDataProducts(dataProd); 
                msNotification('success', 'Producto', 'Se actualizó el producto.' );
            } catch (error) {
                msNotification('error', 'Producto', 'Error al actualizar el producto.' );
            } finally {
              setModalVisibleEdit(false);
            }
        }
        async function updateImageProduct(){
          try {
            const { data } = await updateProductImage(idProduct, requestImage);
            const dataProd = [...dataProducts];
            dataProd.find(x => x.id === idProduct).uriThumbnail = data.image.uriThumbnail;
            setDataProducts(dataProd);
            msNotification('success', 'Producto', 'Se actualizó la imagen del producto.' );
          } catch (error) {
            msNotification('error', 'Producto', 'Error al actualizar la imagen del producto.' );
          } finally {
            setModalVisibleEdit(false);
          }
        }
        if(datac.prodName !== nameProduct && datac.prodDesc !== descProduct && datac.prodPrice !== priceProduct){
            updateTheProduct();
        }
        if(datac.image !== null){
            updateImageProduct();
        }
        
    }
  
    const handleCancelModalNew = () =>{
        setModalVisibleNew(false);
    }

    const handleCancelModalEdit = () =>{
        setModalVisibleEdit(false);
    }

    const columns = [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: 'Producto',
          dataIndex: 'name'
        },
        {
            title: 'Descripción',
            dataIndex: 'description'
        },
        {
            title: 'Precio',
            dataIndex: 'price',
            render: (value) => (`$ ${value} MXN`)
        },
        {
          title: '',
          dataIndex: 'uriThumbnail',
          align: 'center',
          key: 'uriThumbnail',
          render: (value) => ( value !== null ? <img className='imgTableProd' src={origin + value} /> : "")
        },
        {
          title: '',
          dataIndex: 'active',
          align: 'center',
          key: 'active',
          render: (value, record) => (<Switch checked={value} onChange={(checked) => onChangeActive(record, checked)} />)
        },
        {
          title: '',
          align: 'center',
          render: (value, record) => (<Tooltip title="Editar">
              <Button type="primary" shape="circle" onClick={() => handleClickModalEdit(record)} icon={<FaPencilAlt />} />
            </Tooltip>)
        },
      ];


    return(
        <div className="mainContainer">

            <ProductModalNew modalVisibleNew={modalVisibleNew} 
              handleCancelModalNew={handleCancelModalNew}
              handleOkModalNew={handleOkModalNew}/>

            <ProductModalEdit modalVisibleEdit={modalVisibleEdit} 
              handleCancelModalEdit={handleCancelModalEdit}
              handleOkModalEdit={handleOkModalEdit}
              urlThumbnail={urlThumbnail}
              nameProduct={nameProduct}
              descProduct={descProduct}
              priceProduct={priceProduct}
              idProduct={idProduct}/>

            <Row>
                <Col span={24}>
                    <h1 className="title">Productos</h1>
                    <hr className="hr-title"/>
                </Col>
            </Row>

            <Row className="detailContainer">
                <Col span={24}>
                    <div className="divRight">
                        <Button type="primary" icon={<FaPlusCircle/>} onClick={handleClickModalNew} disabled={btnNewDisabled}>
                          &nbsp; Nuevo
                        </Button>
                    </div>
                </Col>
                <Col span={24}>
                    <Select defaultValue="S" style={{ width: '35%' }} onChange={handleChangeCategory}>
                        <Option value="S">Selecciona una Categoría</Option>
                        {dataCategories.map(function(obj){
                            return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                        })}
                    </Select>
                </Col>
                <Col span={24}>
                    <br/>
                    <Table rowKey="id" dataSource={dataProducts} columns={columns} loading={tableProductsLoading}/>
                </Col>
            </Row>

        </div>
    )    

}

export default Products;


// WEBPACK FOOTER //
// ./src/components/Products.jsx